import { BorderGridContainer, GridBox, H4 } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import styled from 'styled-components';

import Banner from '../../../elements/banner';
import content from './content';
import ContentBlock from './components/content-block';
import Head from '../../../../utils/head';
import InsuranceSection from '../components/section';

const StyledInsuranceSection = styled(InsuranceSection)`
  padding-bottom: 8rem;
`;

const FULL_WIDTH_COLS = 12;

const UsefulDocumentsPage = () => {
  const meta = content?.meta;

  return (
    <>
      <Head titleTemplate="%s - ahm life insurance">
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
      </Head>
      <BorderGridContainer hideBorderTop>
        <Banner {...content.banner} />
        <GridBox padding="0">
          <StyledInsuranceSection dfContentCols={FULL_WIDTH_COLS}>
            {map(
              (data) => (
                <ContentBlock key={data.heading} {...data} />
              ),
              content.content,
            )}
          </StyledInsuranceSection>
          <StyledInsuranceSection dfContentCols={FULL_WIDTH_COLS} theme="grey10" id="terms">
            <H4 variant="marginBottomSpacer9">Things you should know</H4>
            {content.thingsYouShouldKnow}
          </StyledInsuranceSection>
        </GridBox>
      </BorderGridContainer>
    </>
  );
};

export default UsefulDocumentsPage;
